import { type ReactElement } from "react";

import { cn } from "../utils/cn";
import { SCORE_DIMENSIONS, scoreBgStyle, scoreColorStyle, type SubScores } from "./scoring";

export interface SubScoreGridProps {
  sub: SubScores;
  className?: string;
}

export function SubScoreGrid({ sub, className }: SubScoreGridProps): ReactElement {
  return (
    <div className="@container">
      <div
        aria-label="Sub-Scores"
        // By the space the card gives it: 1, 2×2 or 4 in a row, so a full label
        // („ANFORDERUNGEN") always fits and no tile sits alone (#163).
        className={cn(
          "grid grid-cols-1 gap-2.5 @[18rem]:grid-cols-2 @[36rem]:grid-cols-4",
          className,
        )}
      >
        {SCORE_DIMENSIONS.map((d) => {
          const v = sub[d.key] ?? 0;
          const Icon = d.icon;
          return (
            <div
              key={d.key}
              className="min-w-0 rounded-md border border-border-default bg-neutral-0 px-2.5 py-2.5 sm:px-3"
            >
              <div className="flex min-w-0 items-center gap-1.5 text-[11px] font-medium uppercase text-text-tertiary wrap-break-word sm:tracking-wider">
                <Icon size={11} className="shrink-0" aria-hidden="true" /> {d.label}
              </div>
              <div className="mt-1.5 flex items-baseline gap-1.5">
                <span
                  className="tabular-nums text-[22px] font-bold -tracking-[0.5px] leading-none"
                  style={scoreColorStyle(v)}
                >
                  {v}
                </span>
                <span className="text-[10px] text-text-tertiary">/ 100</span>
              </div>
              <div className="mt-1.5 h-[3px] overflow-hidden rounded-[2px] bg-neutral-100">
                <div
                  aria-hidden="true"
                  style={{ width: `${v}%`, ...scoreBgStyle(v) }}
                  className="h-full"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
